import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import Checkbox from 'react-bootstrap/lib/Checkbox';

@inject('mixStore')
@observer
class MixCheckbox extends Component {
  render() {
    const { mixStore, id } = this.props;
    const checked = mixStore.checked.get(id);

    return (
      <div className="mix-checkbox" onClick={e => e.stopPropagation()}>
        <Checkbox
          value={checked}
          checked={!!checked}
          onChange={() => mixStore.toggleCheck(id)}
        />
      </div>
    );
  }
}

@inject('mixStore')
@observer
class MixMainCheckbox extends Component {
  render() {
    const { mixStore } = this.props;

    return (
      <div className="mix-checkbox" onClick={e => e.stopPropagation()}>
        <Checkbox
          onChange={e => {
            e.target.checked ? mixStore.checkAll() : mixStore.uncheckAll();
          }}
        />
      </div>
    );
  }
}

export { MixCheckbox, MixMainCheckbox };
